import { buildDownloadData } from '@/pages/intelligence/utils/commonUtils';

const SENSORTOWER = 'sensortower';
const APPANNIE = 'appannie';

// 使用buildDownloadData，获取GenreProfileDetailStats下载表头与表体
export const expandDataGenreProfileDetailStatsPlus = (
  list: any,
  params: any = {},
  downloadKey = '',
) => {
  // console.log('expandDataGenreProfileDetailStatsPlus-list1212', list);
  // console.log('expandDataGenreProfileDetailStatsPlus-params1212', params);
  const listTemp = list.list || [];
  const gameInfoObj = list.entity_detail?.game || {};
  const companyInfoObj = list.entity_detail?.company || {};

  // key支持的取值（string和function）
  // 不写when默认抓取，否则根据when的结果
  // console.log('expandDataCommon-listTemp', listTemp);
  // listTemp = listTemp.sort((a: any, b: any) => {
  //   // 第一优先级：按 gameId 升序
  //   if (a.game_id !== b.game_id) return a.game_id - b.game_id;
  //   // 第二优先级：按 time 降序（新时间在前）
  //   if (b.date !== a.date) return moment(b?.date).diff(moment(a?.date));
  //   // 第三优先级: 国家字母升序
  //   const deviceCompare = a?.market?.localeCompare(b?.market);
  //   if (deviceCompare !== 0) return deviceCompare;
  //   // 第四优先级：按 device 字母升序（A-Z）
  //   return 0;
  // });
  let config: any = [];
  const isSubGenre = params?.genre_tab === 'sub';

  const commonMetricList = [
    {
      title: 'Revenue(appannie)',
      key: (item: any) => item?.metrics?.appannie_revenue || '',
      when: () => params.dataSource === APPANNIE,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.appannie_revenue_growth || '',
      when: () => params.dataSource === APPANNIE && params.ratio_show == '1',
    },
    {
      title: 'Revenue(sensortower)',
      key: (item: any) => item?.metrics?.sensortower_revenue || '',
      when: () => params.dataSource === SENSORTOWER,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.sensortower_revenue_growth || '',
      when: () => params.dataSource === SENSORTOWER && params.ratio_show == '1',
    },
    {
      title: 'Download(appannie)',
      key: (item: any) => item?.metrics?.appannie_download || '',
      when: () => params.dataSource === APPANNIE,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.appannie_download_growth || '',
      when: () => params.dataSource === APPANNIE && params.ratio_show == '1',
    },
    {
      title: 'Download(sensortower)',
      key: (item: any) => item?.metrics?.sensortower_download || '',
      when: () => params.dataSource === SENSORTOWER,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics?.sensortower_download_growth || '',
      when: () => params.dataSource === SENSORTOWER && params.ratio_show == '1',
    },
  ];

  if (downloadKey === 'genreProfileDetailStats-Operation Data') {
    config = [
      {
        title: 'Genre',
        key: (item: any) => (isSubGenre ? item?.sub_genre : item?.genre) || '',
      },
      {
        title: 'Date',
        key: (item: any) => item?.date || '',
        when: () => params.downlaod_date_method !== 'aggregated',
      },
      ...commonMetricList,
    ];
  } else if (downloadKey === 'genreProfileDetailStats-Game Data') {
    config = [
      {
        title: 'Game Name',
        key: (item: any) => gameInfoObj[item.game_id]?.entity_name || '',
      },
      {
        title: 'CompanyName',
        key: (item: any) => gameInfoObj[item.game_id]?.publisher || '',
      },
      {
        title: 'Company HQ',
        key: (item: any) => gameInfoObj[item.game_id]?.country_abbre || '',
      },
      {
        title: 'Company HQ Name',
        key: (item: any) => gameInfoObj[item.game_id]?.country_name_en || '',
      },
      {
        title: 'Parent Company',
        key: (item: any) => gameInfoObj[item.game_id]?.parent_publisher || '',
      },
      {
        title: 'Release Date',
        key: (item: any) => gameInfoObj[item.game_id]?.release_time || '',
      },
      {
        title: 'Date',
        key: (item: any) => item?.date || '',
        when: () => params.downlaod_date_method !== 'aggregated',
      },
      ...commonMetricList,
      {
        title: 'Avg MAU(appannie)',
        key: (item: any) => item?.metrics?.appannie_avg_mau || '',
        when: () => params.dataSource === APPANNIE,
      },
      {
        title: '%',
        key: (item: any) => item?.metrics?.appannie_avg_mau_growth || '',
        when: () => params.dataSource === APPANNIE && params.ratio_show == '1',
      },
      {
        title: 'Avg MAU(sensortower)',
        key: (item: any) => item?.metrics?.sensortower_avg_mau || '',
        when: () => params.dataSource === SENSORTOWER,
      },
      {
        title: '%',
        key: (item: any) => item?.metrics?.sensortower_avg_mau_growth || '',
        when: () => params.dataSource === SENSORTOWER && params.ratio_show == '1',
      },
      {
        title: 'IEGG Main Genre',
        key: (item: any) => gameInfoObj[item.game_id]?.iegg_genre || '',
      },
      {
        title: 'IEGG Sub Genre',
        key: (item: any) => gameInfoObj[item.game_id]?.iegg_sub_genre || '',
      },
    ];
  } else if (downloadKey === 'genreProfileDetailStats-Country') {
    config = [
      {
        title: 'Genre',
        key: (item: any) => (isSubGenre ? item?.sub_genre : item?.genre) || '',
      },
      {
        title: 'Countries',
        key: (item: any) => item?.market || '',
      },
      {
        title: 'Date',
        key: (item: any) => item?.date || '',
        when: () => params.downlaod_date_method !== 'aggregated',
      },
      ...commonMetricList,
    ];
  } else if (downloadKey === 'genreProfileDetailStats-Company') {
    config = [
      {
        title: 'Genre',
        key: (item: any) => (isSubGenre ? item?.sub_genre : item?.genre) || '',
      },
      {
        title: 'CompanyName',
        key: (item: any) => companyInfoObj[item.publisher_id]?.name || '',
      },
      {
        title: 'City',
        key: (item: any) => companyInfoObj[item.publisher_id]?.location_identifiers_city || '',
      },
      {
        title: 'Country',
        key: (item: any) => companyInfoObj[item.publisher_id]?.location_identifiers_country || '',
      },
      {
        title: 'Date',
        key: (item: any) => item?.date || '',
        when: () => params.downlaod_date_method !== 'aggregated',
      },
      ...commonMetricList,
    ];
  }

  const result = buildDownloadData(config, listTemp);
  // console.log('yao-result', result);
  return result;
};
